const defaultMap = {
    seats: {
        'BALCONY': [
            [
                {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '67.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '99.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '131.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '183.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '199.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '231.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '247.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '299.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '315.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '347.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '363.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '415.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '431.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '463.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '479.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '531.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '547.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '579.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '595.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '647.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '663.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '70.5',
                    y: '695.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '96.5',
                    y: '711.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '138.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 138.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '154.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 154.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '186.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 186.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '202.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 202.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '282.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 282.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '298.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 298.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '330.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 330.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '346.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 346.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '426.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 426.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '442.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 442.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '474.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 474.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '490.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 490.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '570.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 570.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '586.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 586.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '618.5',
                    y: '876.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 618.5 876.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '634.5',
                    y: '850.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 634.5 850.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 595)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 579)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 547)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 531)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 479)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 463)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 431)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 415)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 363)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 347)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 315)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 299)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 247)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 231)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 199)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 183)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 131)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 115)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 729 83)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 703 67)'
                },
            ], [
                {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '67.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '99.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '131.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '183.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '199.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '231.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '247.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '299.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '315.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '347.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '363.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '415.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '431.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '463.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '479.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '531.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '547.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '579.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '595.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '647.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '663.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
    
                }, {
                    width: '19',
                    height: '27',
                    x: '.5',
                    y: '695.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '26.5',
                    y: '711.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5'
                }, {
                    width: '19',
                    height: '27',
                    x: '138.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 138.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '154.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 154.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '186.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 186.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '202.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 202.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '246.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 246.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '262.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 262.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '294.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 294.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '310.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 310.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '354.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 354.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '370.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 370.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '402.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 402.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '418.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 418.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '462.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 462.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '478.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 478.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '510.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 510.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '526.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 526.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '570.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 570.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '586.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 586.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '618.5',
                    y: '946.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 618.5 946.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '634.5',
                    y: '920.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 634.5 920.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 711)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 695)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 663)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 647)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 595)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 579)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 547)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 531)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 479)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 415)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 363)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 347)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 315)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 299)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 247)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 215)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 183)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 131)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 799 99)'
                }, {
                    width: '19',
                    height: '27',
                    x: '-.5',
                    y: '.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'matrix(-1 0 0 1 773 67)'
                }
            ], [
                {
                    width: '19',
                    height: '27',
                    x: '202.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 202.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '218.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 218.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '250.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 250.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '266.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 266.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '310.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 310.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '310.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 310.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '342.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 342.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '386.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 386.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '418.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 418.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '418.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 418.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '462.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 462.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '478.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 478.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '510.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 510.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '526.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 526.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '570.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 570.5 990.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '586.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 586.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '618.5',
                    y: '1016.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 618.5 1016.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '634.5',
                    y: '990.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 634.5 990.5)'
                },
            ], [
                {
                    width: '19',
                    height: '27',
                    x: '202.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 202.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '218.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 218.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '250.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 250.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '266.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 266.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '310.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 310.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '310.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 310.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '342.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 342.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '386.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 386.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '418.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 418.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '418.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 418.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '462.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 462.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '478.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 478.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '510.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 510.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '526.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 526.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '570.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 570.5 1060.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '586.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 586.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '618.5',
                    y: '1086.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 618.5 1086.5)'
                }, {
                    width: '19',
                    height: '27',
                    x: '634.5',
                    y: '1060.5',
                    fill: '#36BFFA',
                    stroke: '#36BFFA',
                    rx: '2.5',
                    transform: 'rotate(-90 634.5 1060.5)'
                }
            ]
        ],
        'FAN': [
            [{
                width: '520',
                height: '747',
                x: '140',
                y: '60',
                fill: '#1D2939',
                rx: '3',
                allowMultipleBuy: true
            },]
        ],
    },
    static: [
        {
            width: '520',
            height: '56',
            x: '140',
            fill: '#344054',
            rx: '3'
        }, {
            width: '19',
            height: '27',
            x: '26.5',
            y: '99.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 773 99)'
        }, {
            width: '19',
            height: '27',
            x: '26.5',
            y: '215.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 773 215)'
        }, {
            width: '19',
            height: '27',
            x: '26.5',
            y: '331.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 773 331)'
        }, {
            width: '19',
            height: '27',
            x: '26.5',
            y: '447.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 773 447)'
        }, {
            width: '19',
            height: '27',
            x: '26.5',
            y: '563.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 773 563)'
        }, {
            width: '19',
            height: '27',
            x: '26.5',
            y: '679.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 773 679)'
        }, {
            width: '19',
            height: '27',
            x: '96.5',
            y: '99.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '96.5',
            y: '215.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '96.5',
            y: '331.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '96.5',
            y: '447.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '96.5',
            y: '563.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '96.5',
            y: '679.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5'
        }, {
            width: '19',
            height: '27',
            x: '170.5',
            y: '850.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 170.5 850.5)'
        }, {
            width: '19',
            height: '27',
            x: '314.5',
            y: '850.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 314.5 850.5)'
        }, {
            width: '19',
            height: '27',
            x: '458.5',
            y: '850.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 458.5 850.5)'
        }, {
            width: '19',
            height: '27',
            x: '602.5',
            y: '850.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 602.5 850.5)'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 703 563)'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 703 447)'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 703 331)'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 703 215)'
        }, {
            width: '19',
            height: '27',
            x: '-.5',
            y: '.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'matrix(-1 0 0 1 703 99)'
        }, {
            width: '19',
            height: '27',
            x: '170.5',
            y: '920.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 170.5 920.5)'
        }, {
            width: '19',
            height: '27',
            x: '278.5',
            y: '920.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 278.5 920.5)'
        }, {
            width: '19',
            height: '27',
            x: '386.5',
            y: '920.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 386.5 920.5)'
        }, {
            width: '19',
            height: '27',
            x: '494.5',
            y: '920.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 494.5 920.5)'
        }, {
            width: '19',
            height: '27',
            x: '602.5',
            y: '920.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 602.5 920.5)'
        }, {
            width: '19',
            height: '27',
            x: '234.5',
            y: '990.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 234.5 990.5)'
        }, {
            width: '19',
            height: '27',
            x: '342.5',
            y: '990.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 342.5 990.5)'
        }, {
            width: '19',
            height: '27',
            x: '386.5',
            y: '990.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 386.5 990.5)'
        }, {
            width: '19',
            height: '27',
            x: '494.5',
            y: '990.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 494.5 990.5)'
        }, {
            width: '19',
            height: '27',
            x: '602.5',
            y: '990.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 602.5 990.5)'
        }, {
            width: '19',
            height: '27',
            x: '234.5',
            y: '1060.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 234.5 1060.5)'
        }, {
            width: '19',
            height: '27',
            x: '342.5',
            y: '1060.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 342.5 1060.5)'
        }, {
            width: '19',
            height: '27',
            x: '386.5',
            y: '1060.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 386.5 1060.5)'
        }, {
            width: '19',
            height: '27',
            x: '494.5',
            y: '1060.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 494.5 1060.5)'
        }, {
            width: '19',
            height: '27',
            x: '602.5',
            y: '1060.5',
            fill: '#667085',
            stroke: '#667085',
            rx: '9.5',
            transform: 'rotate(-90 602.5 1060.5)'
        }, {
            svgTag: 'path',
            fill: '#000',
            d: 'M328.745 394.611h4.411c1.704 0 3.217.366 4.538 1.097a7.934 7.934 0 0 1 3.111 3.09c.753 1.321 1.129 2.869 1.129 4.644 0 1.733-.376 3.25-1.129 4.549a7.947 7.947 0 0 1-3.111 3.037c-1.321.717-2.834 1.076-4.538 1.076h-4.411c-1.711 0-3.231-.355-4.559-1.066a7.87 7.87 0 0 1-3.111-3.025c-.753-1.3-1.129-2.82-1.129-4.56 0-1.775.38-3.324 1.14-4.645a8.002 8.002 0 0 1 3.121-3.089c1.328-.739 2.841-1.108 4.538-1.108Zm0 3.345c-1.037 0-1.935.213-2.695.639-.753.419-1.335 1.037-1.747 1.854-.412.817-.618 1.818-.618 3.004 0 1.136.206 2.099.618 2.887a4.279 4.279 0 0 0 1.768 1.801c.76.412 1.652.618 2.674.618h4.422c1.029 0 1.917-.206 2.663-.618a4.23 4.23 0 0 0 1.736-1.811c.412-.796.618-1.758.618-2.888 0-1.171-.206-2.166-.618-2.982-.404-.817-.983-1.439-1.736-1.865-.746-.426-1.634-.639-2.663-.639h-4.422Zm4.113-6.158v23.097h-3.804v-23.097h3.804ZM347.325 414h-4.219l7.681-21.818h4.88L363.358 414h-4.218l-5.828-17.344h-.17L347.325 414Zm.138-8.555h11.506v3.175h-11.506v-3.175ZM366.232 414v-21.818h3.952v9.236h10.111v-9.236h3.963V414h-3.963v-9.268h-10.111V414h-3.952Zm37.383.298c-1.534 0-2.898-.262-4.091-.788-1.186-.526-2.124-1.257-2.813-2.195-.688-.937-1.054-2.02-1.097-3.249h4.006c.035.59.231 1.104.586 1.545.355.433.827.77 1.417 1.012.589.241 1.25.362 1.981.362.781 0 1.474-.135 2.078-.405.603-.277 1.076-.66 1.417-1.15.34-.49.507-1.055.5-1.694.007-.661-.163-1.243-.511-1.747-.348-.505-.852-.899-1.513-1.183-.653-.284-1.442-.426-2.365-.426h-1.928v-3.047h1.928c.76 0 1.424-.131 1.992-.394.576-.263 1.027-.632 1.353-1.108.327-.483.487-1.041.48-1.673.007-.618-.132-1.154-.416-1.608a2.8 2.8 0 0 0-1.182-1.076c-.505-.256-1.098-.384-1.78-.384-.667 0-1.285.121-1.853.362a3.374 3.374 0 0 0-1.374 1.034c-.349.44-.533.966-.554 1.576h-3.804c.029-1.221.38-2.294 1.055-3.217.682-.93 1.591-1.655 2.727-2.173 1.137-.526 2.411-.788 3.825-.788 1.456 0 2.72.273 3.792.82 1.08.54 1.914 1.268 2.504 2.184.589.916.884 1.928.884 3.036.007 1.229-.355 2.259-1.086 3.089-.725.831-1.677 1.375-2.856 1.63v.171c1.535.213 2.71.781 3.527 1.704.824.917 1.232 2.057 1.225 3.42 0 1.222-.348 2.316-1.044 3.281-.689.959-1.641 1.712-2.855 2.259-1.208.547-2.593.82-4.155.82Zm31.419-11.207c0 2.351-.44 4.364-1.321 6.04-.873 1.669-2.066 2.948-3.579 3.836-1.506.887-3.214 1.331-5.124 1.331-1.911 0-3.623-.444-5.135-1.331-1.506-.895-2.699-2.177-3.58-3.846-.873-1.676-1.31-3.686-1.31-6.03 0-2.351.437-4.361 1.31-6.03.881-1.676 2.074-2.958 3.58-3.846 1.512-.888 3.224-1.331 5.135-1.331 1.91 0 3.618.443 5.124 1.331 1.513.888 2.706 2.17 3.579 3.846.881 1.669 1.321 3.679 1.321 6.03Zm-3.973 0c0-1.655-.26-3.051-.778-4.187-.511-1.143-1.222-2.006-2.131-2.589-.909-.589-1.956-.884-3.142-.884s-2.234.295-3.143.884c-.909.583-1.623 1.446-2.142 2.589-.511 1.136-.767 2.532-.767 4.187 0 1.655.256 3.054.767 4.197.519 1.137 1.233 2 2.142 2.589.909.583 1.957.874 3.143.874 1.186 0 2.233-.291 3.142-.874.909-.589 1.62-1.452 2.131-2.589.518-1.143.778-2.542.778-4.197Zm7.71 10.909v-21.818h3.953v9.236h10.11v-9.236h3.963V414h-3.963v-9.268h-10.11V414h-3.953Zm25.126 0h-4.219l7.682-21.818h4.879L479.931 414h-4.219l-5.828-17.344h-.17L463.897 414Zm.139-8.555h11.505v3.175h-11.505v-3.175Z'
        }, {
            svgTag: 'path',
            fill: '#fff',
            d: 'M366.536 24.543h-3.984a4.955 4.955 0 0 0-.629-1.736 4.67 4.67 0 0 0-1.139-1.3 4.753 4.753 0 0 0-1.556-.799 6.066 6.066 0 0 0-1.864-.277c-1.186 0-2.237.298-3.154.895-.916.59-1.633 1.456-2.152 2.6-.518 1.136-.777 2.524-.777 4.165 0 1.669.259 3.075.777 4.219.526 1.136 1.243 1.995 2.152 2.578.917.575 1.964.863 3.143.863.654 0 1.264-.085 1.833-.256a5.009 5.009 0 0 0 1.544-.778c.462-.34.849-.76 1.162-1.257a4.761 4.761 0 0 0 .66-1.704l3.984.021a8.579 8.579 0 0 1-.969 2.919 8.611 8.611 0 0 1-1.928 2.408 8.895 8.895 0 0 1-2.792 1.619c-1.065.383-2.247.575-3.547.575-1.918 0-3.629-.444-5.135-1.331-1.506-.888-2.692-2.17-3.558-3.846-.867-1.676-1.3-3.686-1.3-6.03 0-2.35.437-4.36 1.31-6.03.874-1.676 2.064-2.958 3.569-3.846 1.506-.888 3.21-1.331 5.114-1.331 1.214 0 2.344.17 3.388.51a8.68 8.68 0 0 1 2.791 1.503 7.981 7.981 0 0 1 2.013 2.408c.533.944.881 2.024 1.044 3.238Zm23.808 11.154-.288 8.46h-3.835V39h-1.534v-3.303h5.657ZM370.156 39V17.182h3.793v18.537h9.801V17.182h3.824V39h-17.418Zm23.408 0V17.182h14.19v3.313h-10.237v5.923h9.502v3.314h-9.502v5.955h10.323V39h-14.276Zm18.223 0V17.182h3.952v9.236h10.11v-9.236h3.963V39h-3.963v-9.268h-10.11V39h-3.952Zm25.126 0h-4.219l7.681-21.818h4.879L452.946 39h-4.219L442.9 21.656h-.17L436.913 39Zm.138-8.555h11.506v3.175h-11.506v-3.175Z'
        }, {
            svgTag: 'path',
            fill: '#E4E7EC',
            d: 'M113 54.415H99.91v-4.423c0-1.027.184-1.867.555-2.519.367-.656.863-1.142 1.49-1.457.626-.316 1.325-.473 2.096-.473.771 0 1.472.157 2.103.473.631.31 1.134.792 1.509 1.444.37.652.556 1.487.556 2.506v3.17h-1.407v-3.119c0-.703-.121-1.268-.364-1.694a2.174 2.174 0 0 0-.984-.927 3.289 3.289 0 0 0-1.413-.294c-.524 0-.993.098-1.406.294a2.103 2.103 0 0 0-.972.934c-.238.43-.358 1.001-.358 1.713v2.787H113v1.585Zm0-17.128h-8.438v2.608c0 .588.137 1.05.41 1.387.272.337.647.505 1.125.505.468 0 .837-.151 1.105-.453.269-.307.403-.727.403-1.26v-3.17h1.406v3.17c0 .665-.117 1.238-.351 1.72a2.575 2.575 0 0 1-1.004 1.112c-.439.26-.959.39-1.559.39-.606 0-1.125-.137-1.56-.41a2.658 2.658 0 0 1-1.004-1.169c-.234-.511-.351-1.119-.351-1.822v-4.04H113v1.432Zm0 6.546-4.884-2.787v-1.637L113 42.196v1.637Zm2.812-9.699h-4.218v-.818a3.763 3.763 0 0 0-.678-.518 4.158 4.158 0 0 0-.863-.377 7.982 7.982 0 0 0-1.227-.28 25.926 25.926 0 0 0-1.758-.205l-3.886-.333v-6.239h8.412v-1.508h4.218v1.508H113v7.262h2.812v1.508Zm-4.218-2.53v-4.731h-7.006v3.324l2.48.256a27.74 27.74 0 0 1 2.691.396c.767.158 1.379.409 1.835.754Zm-11.685-19.39H113V13.8h-11.429v.076l2.122 3.196h-1.611L99.909 13.8v-1.586ZM113 1086.41H99.91v-4.42c0-1.03.184-1.87.555-2.52.367-.65.863-1.14 1.49-1.45.626-.32 1.325-.48 2.096-.48.771 0 1.472.16 2.103.48.631.31 1.134.79 1.509 1.44.37.65.556 1.49.556 2.51v3.17h-1.407v-3.12c0-.71-.121-1.27-.364-1.7a2.182 2.182 0 0 0-.984-.92c-.418-.2-.889-.3-1.413-.3s-.993.1-1.406.3c-.413.19-.737.5-.972.93-.238.43-.358 1-.358 1.71v2.79H113v1.58Zm0-17.12h-8.438v2.61c0 .58.137 1.05.41 1.38.272.34.647.51 1.125.51.468 0 .837-.15 1.105-.46.269-.3.403-.72.403-1.26v-3.17h1.406v3.17c0 .67-.117 1.24-.351 1.72a2.55 2.55 0 0 1-1.004 1.12c-.439.26-.959.39-1.559.39-.606 0-1.125-.14-1.56-.41a2.74 2.74 0 0 1-1.004-1.17c-.234-.51-.351-1.12-.351-1.82v-4.04H113v1.43Zm0 6.54-4.884-2.78v-1.64l4.884 2.79v1.63Zm2.812-9.7h-4.218v-.81c-.209-.2-.435-.38-.678-.52a4.07 4.07 0 0 0-.863-.38c-.336-.11-.745-.2-1.227-.28-.486-.08-1.072-.14-1.758-.2l-3.886-.34v-6.24h8.412v-1.5h4.218v1.5H113v7.27h2.812v1.5Zm-4.218-2.53v-4.73h-7.006v3.33l2.48.25c1.027.11 1.924.24 2.691.4.767.16 1.379.41 1.835.75Zm-1.279-14.48h-1.304l-9.102-5.75v-.95h2.02v.64l6.878 4.35h.102v-7.75h1.406v9.46Zm2.685-6.16H99.909v-1.51H113v1.51Zm588 43.45h-13.091v-4.42c0-1.03.185-1.87.556-2.52.367-.65.863-1.14 1.49-1.45.626-.32 1.325-.48 2.096-.48.771 0 1.472.16 2.103.48.631.31 1.134.79 1.509 1.44.37.65.556 1.49.556 2.51v3.17h-1.407v-3.12c0-.71-.121-1.27-.364-1.7a2.182 2.182 0 0 0-.984-.92c-.418-.2-.889-.3-1.413-.3s-.993.1-1.406.3c-.413.19-.737.5-.972.93-.238.43-.358 1-.358 1.71v2.79H701v1.58Zm0-17.12h-8.438v2.61c0 .58.137 1.05.41 1.38.272.34.647.51 1.125.51.468 0 .837-.15 1.105-.46.269-.3.403-.72.403-1.26v-3.17h1.406v3.17c0 .67-.117 1.24-.351 1.72a2.55 2.55 0 0 1-1.004 1.12c-.439.26-.959.39-1.559.39-.606 0-1.125-.14-1.56-.41a2.74 2.74 0 0 1-1.004-1.17c-.234-.51-.351-1.12-.351-1.82v-4.04H701v1.43Zm0 6.54-4.884-2.78v-1.64l4.884 2.79v1.63Zm2.812-9.7h-4.218v-.81c-.209-.2-.435-.38-.678-.52a4.07 4.07 0 0 0-.863-.38c-.336-.11-.745-.2-1.227-.28-.486-.08-1.072-.14-1.758-.2l-3.886-.34v-6.24h8.412v-1.5h4.218v1.5H701v7.27h2.812v1.5Zm-4.218-2.53v-4.73h-7.006v3.33l2.48.25c1.027.11 1.924.24 2.691.4.767.16 1.379.41 1.835.75Zm-1.279-14.48h-1.304l-9.102-5.75v-.95h2.02v.64l6.878 4.35h.102v-7.75h1.406v9.46Zm2.685-6.16h-13.091v-1.51H701v1.51Zm-588-27.55H99.91v-4.42c0-1.03.184-1.87.555-2.52.367-.65.863-1.14 1.49-1.45.626-.32 1.325-.48 2.096-.48.771 0 1.472.16 2.103.48.631.31 1.134.79 1.509 1.44.37.65.556 1.49.556 2.51v3.17h-1.407v-3.12c0-.71-.121-1.27-.364-1.7a2.182 2.182 0 0 0-.984-.92c-.418-.2-.889-.3-1.413-.3s-.993.1-1.406.3c-.413.19-.737.5-.972.93-.238.43-.358 1-.358 1.71v2.79H113v1.58Zm0-17.123h-8.438v2.613c0 .58.137 1.05.41 1.38.272.34.647.51 1.125.51.468 0 .837-.15 1.105-.46.269-.3.403-.72.403-1.26v-3.166h1.406v3.166c0 .67-.117 1.24-.351 1.72a2.55 2.55 0 0 1-1.004 1.12c-.439.26-.959.39-1.559.39-.606 0-1.125-.14-1.56-.41a2.74 2.74 0 0 1-1.004-1.17c-.234-.51-.351-1.12-.351-1.82v-4.045H113v1.432Zm0 6.543-4.884-2.78v-1.64l4.884 2.79v1.63Zm2.812-9.696h-4.218v-.818a3.783 3.783 0 0 0-.678-.518 4.228 4.228 0 0 0-.863-.377 8.115 8.115 0 0 0-1.227-.281 25.337 25.337 0 0 0-1.758-.204l-3.886-.333v-6.238h8.412v-1.509h4.218v1.509H113v7.261h2.812v1.508Zm-4.218-2.531v-4.73h-7.006v3.324l2.48.256c1.027.106 1.924.238 2.691.396.767.158 1.379.409 1.835.754Zm1.585-19.21c0 .844-.145 1.596-.435 2.257-.289.656-.692 1.178-1.208 1.566a3.251 3.251 0 0 1-1.809.626v-1.61a1.907 1.907 0 0 0 1.093-.435c.303-.256.537-.59.703-1.004.167-.413.25-.871.25-1.374 0-.562-.098-1.061-.294-1.496a2.46 2.46 0 0 0-.818-1.022 2.047 2.047 0 0 0-1.215-.371c-.482 0-.906.119-1.272.358-.371.238-.661.588-.869 1.048-.209.46-.314 1.023-.314 1.688v1.048h-1.406v-1.048c0-.52-.094-.976-.281-1.368a2.193 2.193 0 0 0-.793-.927c-.341-.226-.741-.339-1.201-.339-.444 0-.829.098-1.157.294a2.01 2.01 0 0 0-.767.831c-.184.354-.275.771-.275 1.253 0 .452.083.878.249 1.278.162.397.399.72.71.972.306.251.677.388 1.112.409v1.534a3.114 3.114 0 0 1-1.803-.62 3.907 3.907 0 0 1-1.214-1.521 4.914 4.914 0 0 1-.435-2.078c0-.809.164-1.504.492-2.083a3.46 3.46 0 0 1 1.285-1.336 3.366 3.366 0 0 1 1.726-.467c.737 0 1.366.194 1.886.582.519.383.88.905 1.08 1.566h.102c.136-.827.488-1.473 1.055-1.937.562-.465 1.259-.697 2.09-.697.712 0 1.351.194 1.918.582.562.383 1.005.908 1.329 1.572.324.665.486 1.421.486 2.269ZM701 1015.41h-13.091v-4.42c0-1.03.185-1.87.556-2.52.367-.65.863-1.14 1.49-1.45.626-.32 1.325-.48 2.096-.48.771 0 1.472.16 2.103.48.631.31 1.134.79 1.509 1.44.37.65.556 1.49.556 2.51v3.17h-1.407v-3.12c0-.71-.121-1.27-.364-1.7a2.182 2.182 0 0 0-.984-.92c-.418-.2-.889-.3-1.413-.3s-.993.1-1.406.3c-.413.19-.737.5-.972.93-.238.43-.358 1-.358 1.71v2.79H701v1.58Zm0-17.123h-8.438v2.613c0 .58.137 1.05.41 1.38.272.34.647.51 1.125.51.468 0 .837-.15 1.105-.46.269-.3.403-.72.403-1.26v-3.166h1.406v3.166c0 .67-.117 1.24-.351 1.72a2.55 2.55 0 0 1-1.004 1.12c-.439.26-.959.39-1.559.39-.606 0-1.125-.14-1.56-.41a2.74 2.74 0 0 1-1.004-1.17c-.234-.51-.351-1.12-.351-1.82v-4.045H701v1.432Zm0 6.543-4.884-2.78v-1.64l4.884 2.79v1.63Zm2.812-9.696h-4.218v-.818a3.783 3.783 0 0 0-.678-.518 4.228 4.228 0 0 0-.863-.377 8.115 8.115 0 0 0-1.227-.281 25.337 25.337 0 0 0-1.758-.204l-3.886-.333v-6.238h8.412v-1.509h4.218v1.509H701v7.261h2.812v1.508Zm-4.218-2.531v-4.73h-7.006v3.324l2.48.256c1.027.106 1.924.238 2.691.396.767.158 1.379.409 1.835.754Zm1.585-19.21c0 .844-.145 1.596-.435 2.257-.289.656-.692 1.178-1.208 1.566a3.251 3.251 0 0 1-1.809.626v-1.61a1.907 1.907 0 0 0 1.093-.435c.303-.256.537-.59.703-1.004.167-.413.25-.871.25-1.374 0-.562-.098-1.061-.294-1.496a2.46 2.46 0 0 0-.818-1.022 2.047 2.047 0 0 0-1.215-.371c-.482 0-.906.119-1.272.358-.371.238-.661.588-.869 1.048-.209.46-.314 1.023-.314 1.688v1.048h-1.406v-1.048c0-.52-.094-.976-.281-1.368a2.193 2.193 0 0 0-.793-.927c-.341-.226-.741-.339-1.201-.339-.444 0-.829.098-1.157.294a2.01 2.01 0 0 0-.767.831c-.184.354-.275.771-.275 1.253 0 .452.083.878.249 1.278.162.397.399.72.71.972.306.251.677.388 1.112.409v1.534a3.114 3.114 0 0 1-1.803-.62 3.907 3.907 0 0 1-1.214-1.521 4.914 4.914 0 0 1-.435-2.078c0-.809.164-1.504.492-2.083a3.46 3.46 0 0 1 1.285-1.336 3.366 3.366 0 0 1 1.726-.467c.737 0 1.366.194 1.886.582.519.383.88.905 1.08 1.566h.102c.136-.827.488-1.473 1.055-1.937.562-.465 1.259-.697 2.09-.697.712 0 1.351.194 1.918.582.562.383 1.005.908 1.329 1.572.324.665.486 1.421.486 2.269ZM773 54.415h-13.091v-4.423c0-1.027.185-1.867.556-2.519.367-.656.863-1.142 1.49-1.457.626-.316 1.325-.473 2.096-.473.771 0 1.472.157 2.103.473.631.31 1.134.792 1.509 1.444.37.652.556 1.487.556 2.506v3.17h-1.407v-3.119c0-.703-.121-1.268-.364-1.694a2.174 2.174 0 0 0-.984-.927 3.289 3.289 0 0 0-1.413-.294c-.524 0-.993.098-1.406.294a2.103 2.103 0 0 0-.972.934c-.238.43-.358 1.001-.358 1.713v2.787H773v1.585Zm0-17.128h-8.438v2.608c0 .588.137 1.05.41 1.387.272.337.647.505 1.125.505.468 0 .837-.151 1.105-.453.269-.307.403-.727.403-1.26v-3.17h1.406v3.17c0 .665-.117 1.238-.351 1.72a2.575 2.575 0 0 1-1.004 1.112c-.439.26-.959.39-1.559.39-.606 0-1.125-.137-1.56-.41a2.658 2.658 0 0 1-1.004-1.169c-.234-.511-.351-1.119-.351-1.822v-4.04H773v1.432Zm0 6.546-4.884-2.787v-1.637L773 42.196v1.637Zm2.812-9.699h-4.218v-.818a3.763 3.763 0 0 0-.678-.518 4.158 4.158 0 0 0-.863-.377 7.982 7.982 0 0 0-1.227-.28 25.926 25.926 0 0 0-1.758-.205l-3.886-.333v-6.239h8.412v-1.508h4.218v1.508H773v7.262h2.812v1.508Zm-4.218-2.53v-4.731h-7.006v3.324l2.48.256a27.74 27.74 0 0 1 2.691.396c.767.158 1.379.409 1.835.754ZM773 16.816h-1.151l-4.73-4.321a30.084 30.084 0 0 0-1.444-1.253c-.414-.328-.801-.571-1.164-.729a2.815 2.815 0 0 0-1.15-.243c-.46 0-.859.111-1.196.333a2.157 2.157 0 0 0-.779.895 2.89 2.89 0 0 0-.275 1.278c0 .503.104.942.313 1.317.205.37.492.658.863.863.371.2.805.3 1.304.3v1.509c-.767 0-1.44-.177-2.02-.53a3.684 3.684 0 0 1-1.355-1.446c-.324-.613-.486-1.301-.486-2.064 0-.767.162-1.447.486-2.04a3.66 3.66 0 0 1 1.31-1.393 3.447 3.447 0 0 1 1.835-.505c.481 0 .952.088 1.412.262.456.17.966.47 1.528.895.558.422 1.24 1.008 2.046 1.758l3.144 2.94h.103V8.558H773v8.259ZM43 54.415H29.91v-4.423c0-1.027.184-1.867.555-2.519.367-.656.863-1.142 1.49-1.457.626-.316 1.325-.473 2.096-.473.771 0 1.472.157 2.103.473.63.31 1.134.792 1.509 1.444.37.652.556 1.487.556 2.506v3.17h-1.407v-3.119c0-.703-.12-1.268-.364-1.694a2.173 2.173 0 0 0-.984-.927 3.286 3.286 0 0 0-1.413-.294c-.524 0-.993.098-1.406.294a2.098 2.098 0 0 0-.972.934c-.238.43-.358 1.001-.358 1.713v2.787H43v1.585Zm0-17.128h-8.438v2.608c0 .588.137 1.05.41 1.387.272.337.647.505 1.125.505.468 0 .837-.151 1.105-.453.269-.307.403-.727.403-1.26v-3.17h1.406v3.17c0 .665-.117 1.238-.351 1.72a2.573 2.573 0 0 1-1.004 1.112c-.439.26-.959.39-1.56.39-.604 0-1.124-.137-1.56-.41a2.655 2.655 0 0 1-1.003-1.169c-.234-.511-.351-1.119-.351-1.822v-4.04H43v1.432Zm0 6.546-4.883-2.787v-1.637L43 42.196v1.637Zm2.813-9.699h-4.22v-.818a3.76 3.76 0 0 0-.677-.518 4.169 4.169 0 0 0-.863-.377 8.02 8.02 0 0 0-1.227-.28 25.895 25.895 0 0 0-1.758-.205l-3.886-.333v-6.239h8.412v-1.508h4.218v1.508H43v7.262h2.813v1.508Zm-4.22-2.53v-4.731h-7.005v3.324l2.48.256a27.74 27.74 0 0 1 2.691.396c.767.158 1.379.409 1.835.754ZM43 16.816h-1.15l-4.73-4.321a30.014 30.014 0 0 0-1.445-1.253 5.35 5.35 0 0 0-1.164-.729 2.817 2.817 0 0 0-1.15-.243c-.46 0-.859.111-1.195.333a2.155 2.155 0 0 0-.78.895 2.9 2.9 0 0 0-.275 1.278c0 .503.104.942.313 1.317.205.37.492.658.863.863.37.2.805.3 1.304.3v1.509c-.767 0-1.44-.177-2.02-.53a3.687 3.687 0 0 1-1.355-1.446c-.324-.613-.486-1.301-.486-2.064 0-.767.162-1.447.486-2.04a3.654 3.654 0 0 1 1.31-1.393 3.443 3.443 0 0 1 1.835-.505c.481 0 .952.088 1.412.262.456.17.966.47 1.528.895.558.422 1.24 1.008 2.046 1.758l3.145 2.94h.102V8.558H43v8.259Zm658 38.599h-13.091v-4.423c0-1.027.185-1.867.556-2.519.367-.656.863-1.142 1.49-1.457.626-.316 1.325-.473 2.096-.473.771 0 1.472.157 2.103.473.631.31 1.134.792 1.509 1.444.37.652.556 1.487.556 2.506v3.17h-1.407v-3.119c0-.703-.121-1.268-.364-1.694a2.174 2.174 0 0 0-.984-.927 3.289 3.289 0 0 0-1.413-.294c-.524 0-.993.098-1.406.294a2.103 2.103 0 0 0-.972.934c-.238.43-.358 1.001-.358 1.713v2.787H701v1.585Zm0-17.128h-8.438v2.608c0 .588.137 1.05.41 1.387.272.337.647.505 1.125.505.468 0 .837-.151 1.105-.453.269-.307.403-.727.403-1.26v-3.17h1.406v3.17c0 .665-.117 1.238-.351 1.72a2.575 2.575 0 0 1-1.004 1.112c-.439.26-.959.39-1.559.39-.606 0-1.125-.137-1.56-.41a2.658 2.658 0 0 1-1.004-1.169c-.234-.511-.351-1.119-.351-1.822v-4.04H701v1.432Zm0 6.546-4.884-2.787v-1.637L701 43.196v1.637Zm2.812-9.699h-4.218v-.818a3.763 3.763 0 0 0-.678-.518 4.158 4.158 0 0 0-.863-.377 7.982 7.982 0 0 0-1.227-.28 25.926 25.926 0 0 0-1.758-.206l-3.886-.332v-6.239h8.412v-1.508h4.218v1.508H701v7.262h2.812v1.508Zm-4.218-2.53v-4.731h-7.006v3.324l2.48.256a27.74 27.74 0 0 1 2.691.396c.767.158 1.379.409 1.835.754Zm-11.685-19.39H701V14.8h-11.429v.076l2.122 3.196h-1.611l-2.173-3.272v-1.586Z'
        }, {
            svgTag: 'path',
            fill: '#fff',
            d: 'M63 985.146H45.545v-11.225h2.651v8.063h4.09v-3.367c0-1.335.22-2.48.657-3.434.432-.961 1.043-1.696 1.833-2.208.79-.511 1.718-.767 2.786-.767 1.074 0 2.02.256 2.839.767.812.512 1.448 1.247 1.909 2.208.46.954.69 2.099.69 3.434v6.529Zm-2.59-3.162v-3.367c0-.704-.134-1.301-.401-1.79-.267-.488-.62-.858-1.057-1.108a2.778 2.778 0 0 0-1.424-.383c-.738 0-1.366.284-1.883.852-.523.563-.784 1.372-.784 2.429v3.367h5.548Zm2.854-16.172c0 .829-.148 1.576-.443 2.241a3.656 3.656 0 0 1-1.33 1.568c-.585.381-1.306.571-2.164.571-.739 0-1.35-.136-1.833-.409a3.164 3.164 0 0 1-1.159-1.116 5.638 5.638 0 0 1-.656-1.594 12.953 12.953 0 0 1-.332-1.849 72.502 72.502 0 0 0-.214-1.867c-.068-.477-.17-.824-.306-1.04-.142-.221-.361-.332-.657-.332h-.05c-.643 0-1.14.19-1.492.571-.352.381-.529.929-.529 1.645 0 .756.165 1.355.495 1.798.33.438.718.733 1.167.887l-.409 2.88c-.795-.227-1.46-.602-1.994-1.125a4.892 4.892 0 0 1-1.21-1.917c-.273-.756-.41-1.591-.41-2.506 0-.631.075-1.258.222-1.883a5.306 5.306 0 0 1 .733-1.714 3.685 3.685 0 0 1 1.372-1.244c.58-.318 1.304-.477 2.174-.477H63v2.966h-1.798v.102a3.78 3.78 0 0 1 1.022.793c.313.335.566.758.759 1.27.188.505.281 1.099.281 1.781Zm-2.267-.801c0-.62-.122-1.157-.366-1.611a2.703 2.703 0 0 0-.989-1.048 2.518 2.518 0 0 0-1.338-.375h-1.543c.08.096.154.261.222.494.068.227.128.483.179.767.051.284.096.565.136.844l.103.724c.062.46.164.872.306 1.236s.341.65.597.861c.25.21.574.315.972.315.568 0 .997-.207 1.286-.622.29-.415.435-.943.435-1.585Zm2.003-8.31-2.54.017v-.452c0-.341-.077-.628-.23-.86-.153-.233-.409-.427-.767-.58-.364-.153-.852-.273-1.466-.358a23.524 23.524 0 0 0-2.292-.179l-5.796-.23v-9.546H63v2.983H52.44v3.759l4.22.205c1.09.051 2.036.173 2.837.366.796.187 1.452.455 1.969.801.517.341.903.77 1.159 1.287.25.517.375 1.128.375 1.832v.955Zm0-15.294H49.91v-3.085h5.283v-1.125l-5.284-3.938v-3.716l6.426 4.85L63 929.492v3.733l-4.935 3.588v1.509H63v3.085Zm.256-18.835c0 1.278-.282 2.386-.844 3.324-.563.937-1.35 1.664-2.36 2.181-1.012.512-2.194.767-3.546.767-1.353 0-2.537-.255-3.554-.767-1.017-.517-1.807-1.244-2.37-2.181-.562-.938-.843-2.046-.843-3.324 0-1.279.28-2.387.843-3.324.563-.938 1.353-1.662 2.37-2.173 1.017-.517 2.201-.776 3.554-.776 1.352 0 2.534.259 3.545.776 1.011.511 1.798 1.235 2.36 2.173.563.937.845 2.045.845 3.324Zm-2.472-.017c0-.693-.19-1.273-.57-1.739-.387-.466-.904-.812-1.552-1.04-.648-.233-1.37-.349-2.165-.349-.801 0-1.525.116-2.173.349-.654.228-1.173.574-1.56 1.04-.386.466-.58 1.046-.58 1.739 0 .71.194 1.301.58 1.772.387.466.906.816 1.56 1.049.648.227 1.372.341 2.173.341.796 0 1.517-.114 2.165-.341.648-.233 1.165-.583 1.551-1.049.38-.471.571-1.062.571-1.772Zm-5.608-17.866h2.531v6.972h-2.53v-6.972Zm-5.267 6.017H63v2.974H49.91v-2.974Zm0-8.037H63v2.966H49.91v-2.966ZM754 985.146h-17.455v-11.225h2.651v8.063h4.091v-3.367c0-1.335.219-2.48.656-3.434.432-.961 1.043-1.696 1.833-2.208.789-.511 1.718-.767 2.786-.767 1.074 0 2.02.256 2.839.767.812.512 1.448 1.247 1.909 2.208.46.954.69 2.099.69 3.434v6.529Zm-2.591-3.162v-3.367c0-.704-.133-1.301-.4-1.79a2.78 2.78 0 0 0-2.481-1.491c-.738 0-1.366.284-1.883.852-.523.563-.784 1.372-.784 2.429v3.367h5.548Zm2.855-16.172c0 .829-.148 1.576-.443 2.241a3.65 3.65 0 0 1-1.33 1.568c-.585.381-1.306.571-2.164.571-.739 0-1.35-.136-1.833-.409a3.165 3.165 0 0 1-1.159-1.116 5.638 5.638 0 0 1-.656-1.594 12.98 12.98 0 0 1-.332-1.849 78.078 78.078 0 0 0-.213-1.867c-.069-.477-.171-.824-.307-1.04-.142-.221-.361-.332-.657-.332h-.051c-.642 0-1.139.19-1.491.571-.352.381-.529.929-.529 1.645 0 .756.165 1.355.495 1.798.329.438.718.733 1.167.887l-.409 2.88c-.795-.227-1.46-.602-1.994-1.125a4.888 4.888 0 0 1-1.21-1.917c-.273-.756-.409-1.591-.409-2.506 0-.631.073-1.258.221-1.883a5.308 5.308 0 0 1 .733-1.714 3.687 3.687 0 0 1 1.372-1.244c.58-.318 1.304-.477 2.174-.477H754v2.966h-1.798v.102a3.78 3.78 0 0 1 1.022.793c.313.335.566.758.759 1.27.187.505.281 1.099.281 1.781Zm-2.267-.801c0-.62-.122-1.157-.366-1.611a2.705 2.705 0 0 0-.989-1.048 2.518 2.518 0 0 0-1.338-.375h-1.543c.08.096.154.261.222.494.068.227.128.483.179.767.051.284.097.565.136.844l.103.724c.062.46.164.872.306 1.236s.341.65.597.861c.25.21.574.315.972.315.568 0 .997-.207 1.286-.622.29-.415.435-.943.435-1.585Zm2.003-8.31-2.54.017v-.452c0-.341-.076-.628-.23-.86-.153-.233-.409-.427-.767-.58-.364-.153-.852-.273-1.466-.358a23.51 23.51 0 0 0-2.292-.179l-5.796-.23v-9.546H754v2.983h-10.56v3.759l4.219.205c1.091.051 2.037.173 2.838.366.796.187 1.452.455 1.969.801.517.341.903.77 1.159 1.287.25.517.375 1.128.375 1.832v.955Zm0-15.294h-13.091v-3.085h5.284v-1.125l-5.284-3.938v-3.716l6.426 4.85 6.665-4.901v3.733l-4.935 3.588v1.509H754v3.085Zm.256-18.835c0 1.278-.282 2.386-.844 3.324-.563.937-1.35 1.664-2.361 2.181-1.011.512-2.193.767-3.545.767-1.353 0-2.537-.255-3.554-.767-1.017-.517-1.807-1.244-2.37-2.181-.562-.938-.843-2.046-.843-3.324 0-1.279.281-2.387.843-3.324.563-.938 1.353-1.662 2.37-2.173 1.017-.517 2.201-.776 3.554-.776 1.352 0 2.534.259 3.545.776 1.011.511 1.798 1.235 2.361 2.173.562.937.844 2.045.844 3.324Zm-2.472-.017c0-.693-.19-1.273-.571-1.739-.386-.466-.903-.812-1.551-1.04-.648-.233-1.369-.349-2.165-.349-.801 0-1.525.116-2.173.349-.654.228-1.173.574-1.56 1.04-.386.466-.579 1.046-.579 1.739 0 .71.193 1.301.579 1.772.387.466.906.816 1.56 1.049.648.227 1.372.341 2.173.341.796 0 1.517-.114 2.165-.341.648-.233 1.165-.583 1.551-1.049.381-.471.571-1.062.571-1.772Zm-5.608-17.866h2.531v6.972h-2.531v-6.972Zm-5.267 6.017H754v2.974h-13.091v-2.974Zm0-8.037H754v2.966h-13.091v-2.966Z'
        },
        
    ],
    width: '800',
    height: '1088'
};

export default {
    defaultMap
};
